import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { UtilService, VariablesService } from 'src/app/shared/services';
import { SharedModule } from 'src/app/shared/shared.module';

@Component({
  selector: 'app-tip-card-v2',
  standalone: true,
  imports: [
    CommonModule,
    MatInputModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatButtonModule,
    SharedModule,
    MatIconModule
  ],
  templateUrl: './tip-card-v2.component.html',
  styleUrls: ['./tip-card-v2.component.scss']
})
export class TipCardV2Component implements OnInit {

  @Input() baseAmount;
  @Input() currency;
  @Output() tipAmount = new EventEmitter();
  @Output() tipPercent = new EventEmitter();
  otherTipCard: any;
  tips: any;
  selectedTip: any;
  setOtherAmount: any;
  customAmountForm: any;
  customAmount: any;

  constructor(
    public util: UtilService,
    public vars: VariablesService
  ) {}

  ngOnInit(): void {
    this.customAmountForm = new FormGroup({
      customAmount: this.customAmount = new FormControl(this.currency !== 'INR' ? 20 : 100, [Validators.required, Validators.min(0)]),
    });
    this.selectedTip = this.currency !== 'INR' ? 10 : 18;
    this.selectTip({ value: this.selectedTip });
    this.setTipArray();
  }

  setTipArray() {
    this.tips = [];
    const data = [5, 10, 18];
    for (const item of data) {
      this.tips.push({
        percent: item,
        label: `(${this.currency} ${this.calculateTip(item)})`
      });
    }
  }

  selectTip(_event, native?) {
    this.selectedTip = native ? +_event.target.value : +_event.value;
    this.vars.selectTipPercentage = this.selectedTip;
    this.tipAmount.emit(this.calculateTip(this.selectedTip));
    this.tipPercent.emit(this.selectedTip);
  }

  onTipInput() {
    if (!this.customAmount.value) {
      this.customAmount.setValue(0);
    }
    const percent = ((this.customAmount.value * 100) / this.baseAmount).toFixed(2)
    this.tipAmount.emit(this.customAmount.value);
    this.tipPercent.emit(percent);
  }

  calculateTip(tip) {
    console.log('base amount', this.baseAmount)
    return Math.round((this.baseAmount * tip) / 100);
  }

}
